// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_ngx-infinite-scroll_fesm2020_ngx-infinite-scroll_mjs":"a470baf82b37c496","src_app_modules_requests_requests_module_ts":"c4a577ef24196abb","src_app_modules_staffing_staffing_module_ts":"a9f93d0ba588da65","src_app_modules_people_people_module_ts":"aa13a2bdefc33d79"}[chunkId] + ".js";
};